// LineChartComponent.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, LinearScale } from 'chart.js';
import 'chart.js/auto'

const DashboardBarGraph = ({monthlyData = {}}) => {
  const getLabels = () => {
    let myLabels = []
    for (let month in monthlyData) {
      if (monthlyData.hasOwnProperty(month)) { // This check ensures you're not iterating over properties from the prototype chain.
        myLabels.push(month);
      }
      
    }

    return myLabels;
  }

  const getHoursData = () => {
    let myData = []
    Object.keys(monthlyData).forEach(item=>{
      myData.push(monthlyData[item].total_hours)
    })

    return myData;
  }

  const getEmployeesData = () => {
    let employeeData = [];
    Object.keys(monthlyData).forEach(item=>{
      employeeData.push(monthlyData[item].total_employees)
    })

    return employeeData;
  }

  const getTargets = () => {
    let employeeData = [];
    Object.keys(monthlyData).forEach(item=>{
      employeeData.push(8000)
    })

    return employeeData;
  }


  const data = {
    labels: getLabels(),
    datasets: [
      {
        label: 'Hours Done for 2023',
        data: getHoursData(),
        borderColor: '#6C7A89',
        backgroundColor: 'rgba(108, 122, 137, 0.2)',
        pointBackgroundColor: '#6C7A89',
        pointBorderColor: '#34495E',
      },

      {
        label: "Target",
        data: getTargets(),
        borderColor: '#90EE90',
        backgroundColor: 'rgba(144, 238, 144, 0.2)',
        pointBackgroundColor: '#78C878',
        pointBorderColor: '#5DA85D',
      }
    ]
  };

  const options = {
    scales: {
      x: {
        ticks: {
          color: 'white'  // Color for x-axis tick labels
        },
      },
      y: {
        ticks: {
          color: 'white'  // Color for y-axis tick labels
        },
        title: {
          display: true,
          text: 'Hours',
          color: 'white'  // Color for y-axis title
        }
      }
    },
    plugins: {
      legend: {
        labels: {
          color: "white",
          font: {
            size: 12
          }
        }
      },
    },
  };

  return (
    <Line data={data} options={options} />
  );
}

export default DashboardBarGraph;